/*
 * @Author: guang
 * @Date: 2020-12-16 15:49:28
 * @LastEditTime: 2020-12-16 15:57:46
 * @LastEditors: guang
 * @Description:
 */
/**
 * @author szchenyongqin@ininin.com
 * @since 2020-09-07
 * @version 1.0.0
 * @description
 * @copyright ininin.com
 */
class Utils {
  // 获取userAgent信息
  get userAgent () {
    return window.navigator.userAgent.toLowerCase()
  }
  // 判断是否是ios设备
  get isIOS () {
    const keyWords = ['iphone', 'ipad', 'mac']
    const { userAgent } = this
    return keyWords.some(v => userAgent.includes(v))
  }
  // 跳转链接
  transformLocationHref (src) {
    window.location.href = src
  }
  // 下载文件
  downloadFile (src, name) {
    let el = document.createElement('a')
    el.style.display = 'none'
    el.href = src
    el.setAttribute('download', name)
    document.body.appendChild(el)
    el.click()
    document.removeChild(el)
    el = null
  }
}

export default new Utils()
